import { useEffect } from 'react'
import './App.css';
import Keycloak from 'keycloak-js'
import {connect} from 'react-redux'
import {authentication, logoff} from './store/actions/auth'
import Noticias from './components/noticias';
import { ConfigProvider } from 'antd';
import 'antd/dist/antd.css'

function App(props) {

  useEffect( ()=> {
    console.log("carregou")
    const keycloak = new Keycloak({
      url: "https://auth.ariquemes.ifro.edu.br/", 
      realm: "IFRO", 
      clientId: "MuralAdmin"
    })

    keycloak.init({
      onLoad: 'login-required',
      checkLoginIframe: false,
      enableLogging: true
    }).then(authenticated => {
      console.log("Autenticado:", authenticated)
      if (authenticated) {
        keycloak.loadUserInfo().then(userInfo => props.authOK({keycloak: keycloak, userInfo: userInfo}) )
      }
    }).catch(error => {
      console.error("Erro na autenticação:", error)
    })

    keycloak.onTokenExpired = () => {
      console.log("Token expirou!!!!")
      keycloak.updateToken(5).then(function(refreshed) {
        if (refreshed) {
          console.log('Token was successfully refreshed');
        } else {
          console.log('Token is still valid');
        }
      }).catch(function() {
        alert('Failed to refresh the token, or the session has expired');
      })
    }
  }, [])

  if (props.authenticated) {
    return (
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#1890ff',
            borderRadius: 8,
            colorSuccessBg: '#f6ffed',
            colorWarningBg: '#fffbe6',
            colorErrorBg: '#fff1f0',
            colorInfoBg: '#e6f7ff',
          },
          components: {
            Button: {
              controlHeight: 40,
              borderRadius: 8,
            },
            Card: {
              borderRadiusLG: 12,
            },
            Input: {
              controlHeight: 40,
              borderRadius: 8,
            },
            Select: {
              controlHeight: 40,
              borderRadius: 8,
            },
          },
        }}
      >
        <span>
          <Noticias />
        </span>
      </ConfigProvider>
    )
  }
  else {
      return ( 
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#1890ff',
              borderRadius: 8,
            },
          }}
        >
          <div className="App">
            Não Autenticado
          </div>
        </ConfigProvider>
      )
  }
  
}

function mapStateToProps(state) {

  return {
    
    keycloak: state.auth.keycloak,
    userInfo: state.auth.userInfo,
    authenticated: state.auth.authenticated

  }

}

function mapActionCreatorsToProp(dispatch) {
  return {
    authOK(payload) {
      const action = authentication(payload)
      dispatch(action)
    },

    logoffUser() {
      const action = logoff()
      dispatch(action)
    }
  }
}

export default connect(mapStateToProps, mapActionCreatorsToProp)(App)